<template>
  <div ref="rootRef" class="btn-group dropup" :class="{ show: isOpen }">
    <div
      class="avatar"
      id="dropdownMenuButton"
      :aria-expanded="isOpen"
      @click="toggle"
    >
      <AvatarWidget
        :image-url="profileAvatarUrl"
        :social-avatar="profileAvatarUrl"
        image-size="imageSM"
        :full-name-avatar="userAvatar.fullNameAvatar"
        :alt="userAvatar.fullNameAvatar"
        :title="userAvatar.fullNameAvatar"
      />
    </div>
    <ul class="dropdown-menu" :class="{ show: isOpen }" id="dropdownMenu">
      <div class="dropdown-menu-box animation">
        <template v-for="(item, index) in dropdownMenuList ?? []" :key="index">
          <li>
            <template v-if="!!item.slotName">
              <slot></slot>
            </template>
            <template v-if="!item.slotName">
              <a @click="routePath($event, item.path ?? '')" class="dropdown-item"
                 :class="{'package': !!item.subLabel}">
                <LucideIcon v-if="!!item.icon" :icon="item.icon"/>
                {{ item.label }}
                <div class="sublabels" v-if="item.showPackageLabel">
                  <div v-if="hasFree" class="tag--default tag--neutral">Free</div>
                  <div v-if="hasPro" class="tag--default tag--orange">Pro</div>
                </div>
              </a>
            </template>
          </li>
          <li v-if="!!item.hasDivider">
            <hr class="dropdown-divider">
          </li>
        </template>
      </div>
    </ul>
  </div>
</template>

<script setup lang="ts">
import {computed} from 'vue';
import {useRouter} from 'vue-router';
import {useUserStore} from '@shared/stores/user.store';
import {useWorkspaceStore} from '@shared/stores/workspace.store';
import {useDropdown} from '@shared/composables/use-dropdown';
import AvatarWidget from '@shared/components/widgets/profile/avatar.widget.vue';

defineProps<{
  dropdownMenuList?: Array<{
    label?: string;
    path?: string;
    icon?: string;
    slotName?: string;
    subLabel?: string;
    showPackageLabel?: boolean;
    hasDivider?: boolean;
  }>;
}>();

const userStore      = useUserStore();
const workspaceStore = useWorkspaceStore();
const router         = useRouter();
const {isOpen, rootRef, toggle, close} = useDropdown({placement: 'top-start'});

const hasFree   = computed(() => workspaceStore.hasFreeProduct);
const hasPro    = computed(() => workspaceStore.hasProProduct);
const userAvatar = computed(() => userStore.getUserAvatar);

const profileAvatarUrl = computed(() => {
  if (!userAvatar.value.isUrl) return '';
  if (userAvatar.value.avatar) return `${userAvatar.value.avatar}/imageSM`;
  return userAvatar.value.socialAvatar ?? '';
});

function routePath(e: Event, pathName: string): void {
  void router.push({name: pathName});
  e.preventDefault();
  close();
}
</script>

<style lang="scss" scoped>
.dropdown-menu {
  width: 250px;
}

.dropdown-menu-box {
  padding: 0 !important;
  overflow: hidden !important;
}

.dropdown-item {
  gap: var(--space-4);

  .sublabels {
    display: flex;
    gap: var(--space-4);
    position: absolute;
    right: var(--space-12);
  }
}

</style>
